import React from 'react';
import styles from './index.less';

interface IProps {
    tipMsg: string;
}

type IRef = React.ForwardedRef<HTMLDivElement>;

// 重新生成图片弹窗
export const ReplaceSlideContentLoading = React.forwardRef(({ tipMsg }: IProps, ref: IRef) => (
    <div className={styles.container} ref={ref}>
        <div className={styles.loading}></div>
        <div className={styles.text}>{tipMsg}</div>
    </div>
));

ReplaceSlideContentLoading.displayName = 'replaceSlideContentLoading';
